const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  token: state => state.sys.token,
  name: state => state.sys.name,
  roles: state => state.sys.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  permissions: state => state.sys.permissions,
  layout: state => state.sys.layout,
  dictMap: state => state.sys.dictMap,
  countryMap: state => state.sys.countryMap,
  options: state => state.sys.options,
  admin: state => state.sys.admin,
}
export default getters



// WEBPACK FOOTER //
// ./src/admin/store/getters.js